import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import './attachment.scss';
import { Button } from '@alefeducation/ui-elements-library-core';
import { Download, EyeSolid } from '@alefeducation/ui-elements-library-icons';
import AttachmentPreviewModal, {
  attachmentTypeIconRenderer,
} from '../../common/AttachmentPreviewModal/AttachmentPreviewModal';
import {
  getAttachmentGeneralFileType,
  getDownloadableFileLink,
  getFileLink,
} from '../attachment.utils';
import AssignmentContext from '../../common/AssignmentContext/AssignmentContext';

const NewAttachment = ({ attachment }) => {
  const { t } = useTranslation();
  const isDocument =
    attachment && getAttachmentGeneralFileType(attachment) === 'document';
  const {
    assignmentData: { assignmentType },
  } = useContext(AssignmentContext);
  const assignmentTypeForPendoClass = assignmentType
    .split('_')
    .join('-')
    .toLowerCase();
  return (
    <AttachmentPreviewModal
      testId={'assignment-attachment-preview-modal'}
      title={attachment.fileName}
      loading={false}
      buttonTextCancel={t('Close')}
      attachment={attachment}
      renderProp={setPreviewModal => (
        <div className="attachment__wrapper">
          <div className="attachment__container">
            <div className="attachment__icon_wrapper">
              {attachmentTypeIconRenderer(setPreviewModal, attachment, '')}
            </div>
            <span title={attachment.fileName}>{t('File')}</span>
          </div>

          {!isDocument && (
            <Button
              data-testid="view-teacher-attachment-button"
              variant="secondary"
              size="sm"
              onClick={() => !isDocument && setPreviewModal(true)}
              className={`data-analytics-${assignmentTypeForPendoClass}-student-submission-page-preview-assignment-file`}
              icon={
                <EyeSolid
                  data-testid="view-teacher-attachment-icon"
                  fontSize={18}
                />
              }
            >
              {t('Preview')}
            </Button>
          )}
          {isDocument && (
            <Button
              data-testid="downloadButton"
              icon={<Download fontSize={18} />}
              variant="secondary"
              size="sm"
              className={`data-analytics-${assignmentTypeForPendoClass}-student-submission-page-download-assignment-file`}
              onClick={() =>
                window.open(
                  getDownloadableFileLink(
                    getFileLink(attachment),
                    attachment.fileName,
                  ),
                  '_blank',
                )
              }
            >
              {t('Download')}
            </Button>
          )}
        </div>
      )}
    />
  );
};

NewAttachment.propTypes = {
  attachment: PropTypes.object.isRequired,
};

export default NewAttachment;
